// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirmTransferModal-body{min-width:27vw}.confirmTransferModal .modalV2-header{border-bottom:0}.confirmTransferModal .modalV2-content-wrapper{text-align:center}.confirmTransferModalBody{padding:0 90px 40px;display:flex;flex-direction:column;justify-content:center;align-items:center;width:600px;box-sizing:border-box}.confirmTransferModalBodyTitle{margin-bottom:12px}.confirmTransferModalBody .leftBtn{margin-right:8px}\n", ""]);
// Exports
module.exports = exports;
